import type { SVGProps } from 'react';

const SvgPlusOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill={props.color}
      d="M11 21a1 1 0 1 0 2 0v-8h8a1 1 0 1 0 0-2h-8V3a1 1 0 1 0-2 0v8H3a1 1 0 1 0 0 2h8z"
    />
  </svg>
);

export default SvgPlusOutline;
